import { isNil } from 'lodash'

const clearMiscAndChoiceFromText = styledText =>
  isNil(styledText)
    ? styledText
    : styledText
        .replaceAll('<u>', '')
        .replaceAll('</u>', '')
        .replaceAll('<em>', '')
        .replaceAll('</em>', '')

export default clearMiscAndChoiceFromText
